module.exports = __webpack_public_path__ + "static/media/Amaura_gaussian2.c58df729.png";